import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { nylasActions } from 'features/nylas';

const useNylas = () => {
  const dispatch = useDispatch();
  const createNylas = useCallback((nylas_code) => dispatch(nylasActions.createNylas(nylas_code)), [dispatch]);
  const deleteNylas = useCallback(() => dispatch(nylasActions.deleteNylas()), [dispatch]);

  return { createNylas, deleteNylas };
};

export default useNylas;